import React from 'react'
import { Button } from 'reactstrap'

export const AnalysisRequestSaveButton = ({ handleOnClick, disabled = false }) => {
    return (
        <Button disabled={disabled} className='btn btn-success rounded-3 d-flex align-items-center py-1 ms-1' onClick={handleOnClick} >
            <span className="mdi mdi-18px mdi-content-save me-2"></span>
            Guardar
        </Button>
    )
}

